/**
 * sco design system — spacing tokens.
 * Source of truth. Edit directly.
 */

import { defineTokens } from '@chakra-ui/react'

export const spacing = defineTokens.spacing({
  '0.5': {
    value: '0.125em',
  },
  '1': {
    value: '0.25em',
  },
  '1.5': {
    value: '0.375em',
  },
  '2': {
    value: '0.5em',
  },
  '2.5': {
    value: '0.625em',
  },
  '3': {
    value: '0.75em',
  },
  '3.5': {
    value: '0.875em',
  },
  '4': {
    value: '1em',
  },
  '4.5': {
    value: '1.125em',
  },
  '5': {
    value: '1.25em',
  },
  '6': {
    value: '1.5em',
  },
  '7': {
    value: '1.75em',
  },
  '8': {
    value: '2em',
  },
  '9': {
    value: '2.25em',
  },
  '10': {
    value: '2.5em',
  },
  '11': {
    value: '2.75em',
  },
  '12': {
    value: '3em',
  },
  '14': {
    value: '3.5em',
  },
  '16': {
    value: '4em',
  },
  '20': {
    value: '5em',
  },
  '24': {
    value: '6em',
  },
  '28': {
    value: '7em',
  },
  '32': {
    value: '8em',
  },
  '36': {
    value: '9em',
  },
  '40': {
    value: '10em',
  },
  '44': {
    value: '11em',
  },
  '48': {
    value: '12em',
  },
  '52': {
    value: '13em',
  },
  '56': {
    value: '14em',
  },
  '60': {
    value: '15em',
  },
  '64': {
    value: '16em',
  },
  '72': {
    value: '18em',
  },
  '80': {
    value: '20em',
  },
  '96': {
    value: '24em',
  },
})
